<template>
  <div class="general-stepper">
    <div style="overflow-y:auto;">
      <v-stepper
        ref="stepper"
        v-model="step"
        :steps="numberOfSteps"
        vertical
        @input="stepChange"
      >
        <!--titles steps-->
        <template
          v-for="(currentStep, index) in stepsInfo"
          :slot="'step-' + (index)"
        >
          {{ currentStep.title }}
        </template>
      </v-stepper>
    </div>

    <!--contents steps-->
    <template
      v-for="(currentStep, index) in stepsInfo"
      v-if="step == index"
      class="col-xs-12"
    >
      <slot :name="'content-step-' + String(index)" />
    </template>

    <!--buttons-->
    <div class="col-xs-12">
      <div class="btn-group pull-right">
        <button
          v-if="step !== 1"
          type="button"
          class="btn btn-default"
          @click="$refs.stepper.previous()"
        >
          {{ trans('core.previous') }}
        </button>

        <button
          v-if="step !== numberOfSteps"
          type="button"
          class="btn btn-next"
          :disabled="!finishedStep"
          @click="$refs.stepper.next()"
        >
          {{ trans('core.next') }}
        </button>

        <button
          v-if="step === numberOfSteps"
          type="button"
          class="btn btn-next"
          :disabled="disableSave || !finishedStep"
          @click="finish"
        >
          {{ trans('core.save') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { VStepper } from 'vue-stepper-component'

export default {
  name: 'GeneralStepper',

  components: {
    VStepper,
  },

  props: {
    stepsInfo: { required: true },
    enableSaveButton: { required: false, default: false },
  },

  data () {
    return {
      step: undefined,
      disableSave: false,
    }
  },

  computed: {
    numberOfSteps () {
      return Object.keys(this.stepsInfo).length
    },
    finishedStep () {
      let currentStep = this.stepsInfo[this.step]
      return currentStep === undefined ? false : currentStep.finished
    },
  },

  watch: {
    enableSaveButton (newValue) {
      this.disableSave = !newValue
    },
  },

  methods: {
    finish () {
      this.disableSave = true
      this.$emit('finish')
    },
    stepChange (event) {
      this.$emit('changeStep', { 'step': event })
    },

  },
}
</script>

<style lang="scss">
    .general-stepper {
        .v-stepper > .v-stepper-root > .v-step {
            pointer-events: none;
        }

        .index {
            background-color: #25167a !important;
            color: white !important;
        }

        .title {
            color: black !important;
            font-size: medium;
            margin: 0px 10px;
        }

        .btn-group {
            margin: 0px;
            margin-top: 10px;
        }

        .btn-next {
            background-color: #25167a !important;
            color: white !important;
        }
    }
</style>
